import { createMongoAbility } from '@casl/ability';
import type { InferSubjects, MongoAbility, RawRuleOf } from '@casl/ability';

/** Every subject of a case is a plain object tagged with its type in `kind`. */
export type CaseSubject = { readonly kind: string };

export type CaseAbility<Action extends string, Subject extends CaseSubject> = MongoAbility<
  [Action, InferSubjects<Subject>]
>;

// The one place an ability is created: without `detectSubjectType` CASL reads a plain object as `Object`, so no
// rule applies and every check answers "cannot", with no error.
export const createCaseAbility = <Action extends string, Subject extends CaseSubject>(
  rules: RawRuleOf<CaseAbility<Action, Subject>>[],
): CaseAbility<Action, Subject> =>
  createMongoAbility<CaseAbility<Action, Subject>>(rules, { detectSubjectType: (subject) => subject.kind });
